import React from 'react';

const AppTabPanel = ({
  id,
  hidden,
  'aria-labelledby': ariaLabelledby,
  className,
  children,
}: {
  id?: any,
  hidden: boolean,
  'aria-labelledby'?: string,
  className?: string,
}) => (
  <div
    role="tabpanel"
    hidden={hidden}
    id={id}
    aria-labelledby={ariaLabelledby}
    className={className}
  >
    {children}
  </div>
);

export default AppTabPanel;
